import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchExpenses = (params = {}) => api.get("/expenses", { params }).then((r) => r.data);
export const createExpense = (payload) => api.post("/expenses", payload).then((r) => r.data);
export const updateExpense = (id, payload) => api.put(`/expenses/${id}`, payload).then((r) => r.data);
export const deleteExpense = (id) => api.delete(`/expenses/${id}`).then((r) => r.data);

export const fetchCategories = () => api.get("/categories").then((r) => r.data);
export const createCategory = (payload) => api.post("/categories", payload).then((r) => r.data);
export const updateCategory = (id, payload) => api.put(`/categories/${id}`, payload).then((r) => r.data);
export const deleteCategory = (id) => api.delete(`/categories/${id}`).then((r) => r.data);
export const addSubcategory = (id, sub) => api.post(`/categories/${id}/subcategories`, { subcategory: sub }).then((r) => r.data);
export const deleteSubcategory = (id, sub) => api.delete(`/categories/${id}/subcategories/${encodeURIComponent(sub)}`).then((r) => r.data);

export const fetchSummary = (params = {}) => api.get("/stats/summary", { params }).then((r) => r.data);
export const fetchTrend = (params = {}) => api.get("/stats/monthly-trend", { params }).then((r) => r.data);
export const fetchByCategory = (params = {}) => api.get("/stats/by-category", { params }).then((r) => r.data);
export const fetchBySubcategory = (params = {}) => api.get("/stats/by-subcategory", { params }).then((r) => r.data);
export const fetchYears = () => api.get("/stats/years").then((r) => r.data);

export const fetchBudgets = (params = {}) => api.get("/budgets", { params }).then((r) => r.data);
export const upsertBudget = (payload) => api.post("/budgets", payload).then((r) => r.data);
export const deleteBudget = (id) => api.delete(`/budgets/${id}`).then((r) => r.data);
export const copyBudgets = (params) => api.post("/budgets/copy", null, { params }).then((r) => r.data);
